
export default {
  name: 'TrackingNoscript',
}
